import {
  EntityDropdownInput,
  EntityDropdownProps,
} from "#batteries-included-components/Dropdowns/EntityDropdownInput";
import {
  FlowAdapter,
  type FlowAttributeReferenceType,
} from "@validereinc/domain";
import React from "react";

export const FlowTypeDropdownInput = ({
  name = "type",
  label,
  ...props
}: Omit<
  EntityDropdownProps<FlowAttributeReferenceType[]>,
  "fetchEntityList"
>) => {
  return (
    <EntityDropdownInput
      fetchEntityList={FlowAdapter.types.getList}
      label={label ?? "Type"}
      name={name}
      sort={{
        sortBy: "name",
        sortDirection: "asc",
      }}
      {...props}
    />
  );
};
